export default "__VITE_ASSET__CSa$pUt2__"